
import { toString as toString_1, Record, Union } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { anonRecord_type, float64_type, option_type, int32_type, string_type, record_type, class_type, bool_type, list_type, union_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ReminderDateDto_$reflection, ProcedureId_$reflection, ProcedureStepElementResultId_$reflection, ProcedureStepId_$reflection, ProcedureTemplateStepId_$reflection, InspectionTemplateId_$reflection, ProcedureTemplateStepElementId_$reflection, ProcedureTemplateId_$reflection, ChecklistDefinitionProcessId_$reflection } from "./Shared.js";
import { tryFind, length, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { int32ToString } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { toLocalTime, toString } from "../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { InventoryStateReference_$reflection } from "./InventoryStates.js";

export class ChecklistDefinitionProcessStep extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["ReturnToStorage"];
    }
}

export function ChecklistDefinitionProcessStep_$reflection() {
    return union_type("Shared.Procedure.ChecklistDefinitionProcessStep", [], ChecklistDefinitionProcessStep, () => [[]]);
}

export class FirestoreChecklistProcessStepDefinition extends Record {
    constructor(Id, ChecklistDefinitionId, ProcessStep, IsDeleted, UpdatedAt, CreatedAt) {
        super();
        this.Id = Id;
        this.ChecklistDefinitionId = ChecklistDefinitionId;
        this.ProcessStep = ProcessStep;
        this.IsDeleted = IsDeleted;
        this.UpdatedAt = UpdatedAt;
        this.CreatedAt = CreatedAt;
    }
}

export function FirestoreChecklistProcessStepDefinition_$reflection() {
    return record_type("Shared.Procedure.FirestoreChecklistProcessStepDefinition", [], FirestoreChecklistProcessStepDefinition, () => [["Id", ChecklistDefinitionProcessId_$reflection()], ["ChecklistDefinitionId", ProcedureTemplateId_$reflection()], ["ProcessStep", list_type(ChecklistDefinitionProcessStep_$reflection())], ["IsDeleted", bool_type], ["UpdatedAt", class_type("System.DateTime")], ["CreatedAt", class_type("System.DateTime")]]);
}

export class TextInputStep extends Record {
    constructor(Id, Title, Description, Required, Index) {
        super();
        this.Id = Id;
        this.Title = Title;
        this.Description = Description;
        this.Required = Required;
        this.Index = (Index | 0);
    }
}

export function TextInputStep_$reflection() {
    return record_type("Shared.Procedure.TextInputStep", [], TextInputStep, () => [["Id", class_type("System.Guid")], ["Title", string_type], ["Description", string_type], ["Required", bool_type], ["Index", int32_type]]);
}

export class BoolStep extends Record {
    constructor(Id, Title, Description, Required, Index) {
        super();
        this.Id = Id;
        this.Title = Title;
        this.Description = Description;
        this.Required = Required;
        this.Index = (Index | 0);
    }
}

export function BoolStep_$reflection() {
    return record_type("Shared.Procedure.BoolStep", [], BoolStep, () => [["Id", class_type("System.Guid")], ["Title", string_type], ["Description", string_type], ["Required", bool_type], ["Index", int32_type]]);
}

export class SingleSelectStep extends Record {
    constructor(Id, Title, Description, Required, Values, Index) {
        super();
        this.Id = Id;
        this.Title = Title;
        this.Description = Description;
        this.Required = Required;
        this.Values = Values;
        this.Index = (Index | 0);
    }
}

export function SingleSelectStep_$reflection() {
    return record_type("Shared.Procedure.SingleSelectStep", [], SingleSelectStep, () => [["Id", class_type("System.Guid")], ["Title", string_type], ["Description", string_type], ["Required", bool_type], ["Values", list_type(string_type)], ["Index", int32_type]]);
}

export class MultiSelectStep extends Record {
    constructor(Id, Title, Description, Required, Values, Index) {
        super();
        this.Id = Id;
        this.Title = Title;
        this.Description = Description;
        this.Required = Required;
        this.Values = Values;
        this.Index = (Index | 0);
    }
}

export function MultiSelectStep_$reflection() {
    return record_type("Shared.Procedure.MultiSelectStep", [], MultiSelectStep, () => [["Id", class_type("System.Guid")], ["Title", string_type], ["Description", string_type], ["Required", bool_type], ["Values", list_type(string_type)], ["Index", int32_type]]);
}

export class DateTimeStep extends Record {
    constructor(Id, Title, Description, Required, Index) {
        super();
        this.Id = Id;
        this.Title = Title;
        this.Description = Description;
        this.Required = Required;
        this.Index = (Index | 0);
    }
}

export function DateTimeStep_$reflection() {
    return record_type("Shared.Procedure.DateTimeStep", [], DateTimeStep, () => [["Id", class_type("System.Guid")], ["Title", string_type], ["Description", string_type], ["Required", bool_type], ["Index", int32_type]]);
}

export class Signature extends Record {
    constructor(Id, Title, Description, Required, Index) {
        super();
        this.Id = Id;
        this.Title = Title;
        this.Description = Description;
        this.Required = Required;
        this.Index = (Index | 0);
    }
}

export function Signature_$reflection() {
    return record_type("Shared.Procedure.Signature", [], Signature, () => [["Id", class_type("System.Guid")], ["Title", string_type], ["Description", string_type], ["Required", bool_type], ["Index", int32_type]]);
}

export class ImageStep extends Record {
    constructor(Id, Title, Description, Required, Index) {
        super();
        this.Id = Id;
        this.Title = Title;
        this.Description = Description;
        this.Required = Required;
        this.Index = (Index | 0);
    }
}

export function ImageStep_$reflection() {
    return record_type("Shared.Procedure.ImageStep", [], ImageStep, () => [["Id", class_type("System.Guid")], ["Title", string_type], ["Description", string_type], ["Required", bool_type], ["Index", int32_type]]);
}

export class ChecklistDefinitionStepType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["TextInput", "Bool", "SingleSelect", "MultiSelect", "DateTimeStep", "Signature", "ImageStep"];
    }
}

export function ChecklistDefinitionStepType_$reflection() {
    return union_type("Shared.Procedure.ChecklistDefinitionStepType", [], ChecklistDefinitionStepType, () => [[["Item", TextInputStep_$reflection()]], [["Item", BoolStep_$reflection()]], [["Item", SingleSelectStep_$reflection()]], [["Item", MultiSelectStep_$reflection()]], [["Item", DateTimeStep_$reflection()]], [["Item", Signature_$reflection()]], [["Item", ImageStep_$reflection()]]]);
}

export function ChecklistDefinitionStepType__get_Id(this$) {
    switch (this$.tag) {
        case 1:
            return this$.fields[0].Id;
        case 2:
            return this$.fields[0].Id;
        case 3:
            return this$.fields[0].Id;
        case 4:
            return this$.fields[0].Id;
        case 5:
            return this$.fields[0].Id;
        case 6:
            return this$.fields[0].Id;
        default:
            return this$.fields[0].Id;
    }
}

export function ChecklistDefinitionStepType__get_I18nString(this$) {
    switch (this$.tag) {
        case 1:
            return "checklist.definition.steps.yes_no";
        case 2:
            return "checklist.definition.steps.single_select";
        case 3:
            return "checklist.definition.steps.multi_select";
        case 4:
            return "checklist.definition.steps.date_time";
        case 5:
            return "checklist.definition.steps.signature";
        case 6:
            return "checklist.definition.steps.image";
        default:
            return "checklist.definition.steps.text_input";
    }
}

export function ChecklistDefinitionStepType__get_Required(this$) {
    switch (this$.tag) {
        case 1:
            return this$.fields[0].Required;
        case 2:
            return this$.fields[0].Required;
        case 3:
            return this$.fields[0].Required;
        case 4:
            return this$.fields[0].Required;
        case 5:
            return this$.fields[0].Required;
        case 6:
            return this$.fields[0].Required;
        default:
            return this$.fields[0].Required;
    }
}

export function ChecklistDefinitionStepType__get_Title(this$) {
    switch (this$.tag) {
        case 1:
            return this$.fields[0].Title;
        case 2:
            return this$.fields[0].Title;
        case 3:
            return this$.fields[0].Title;
        case 4:
            return this$.fields[0].Title;
        case 5:
            return this$.fields[0].Title;
        case 6:
            return this$.fields[0].Title;
        default:
            return this$.fields[0].Title;
    }
}

export function ChecklistDefinitionStepType__get_Description(this$) {
    switch (this$.tag) {
        case 1:
            return this$.fields[0].Description;
        case 2:
            return this$.fields[0].Description;
        case 3:
            return this$.fields[0].Description;
        case 4:
            return this$.fields[0].Description;
        case 5:
            return this$.fields[0].Description;
        case 6:
            return this$.fields[0].Description;
        default:
            return this$.fields[0].Description;
    }
}

export class ChecklistDefinitionSingleSelectStep extends Record {
    constructor(Values, IsDeleted) {
        super();
        this.Values = Values;
        this.IsDeleted = IsDeleted;
    }
}

export function ChecklistDefinitionSingleSelectStep_$reflection() {
    return record_type("Shared.Procedure.ChecklistDefinitionSingleSelectStep", [], ChecklistDefinitionSingleSelectStep, () => [["Values", list_type(string_type)], ["IsDeleted", bool_type]]);
}

export class ChecklistDefinitionMultiSelectStep extends Record {
    constructor(Values, IsDeleted) {
        super();
        this.Values = Values;
        this.IsDeleted = IsDeleted;
    }
}

export function ChecklistDefinitionMultiSelectStep_$reflection() {
    return record_type("Shared.Procedure.ChecklistDefinitionMultiSelectStep", [], ChecklistDefinitionMultiSelectStep, () => [["Values", list_type(string_type)], ["IsDeleted", bool_type]]);
}

export class ChecklistDefinitionStepOption extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ChecklistDefinitionSingleSelectStep", "ChecklistDefinitionMultiSelectStep"];
    }
}

export function ChecklistDefinitionStepOption_$reflection() {
    return union_type("Shared.Procedure.ChecklistDefinitionStepOption", [], ChecklistDefinitionStepOption, () => [[["Item", ChecklistDefinitionSingleSelectStep_$reflection()]], [["Item", ChecklistDefinitionMultiSelectStep_$reflection()]]]);
}

export class ProcedureTemplateInformationFieldType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DisplayName", "Manufacturer", "Model", "SerialNumber", "InventoryNumber", "Comment", "StorageName", "StorageSpace", "CustomField"];
    }
}

export function ProcedureTemplateInformationFieldType_$reflection() {
    return union_type("Shared.Procedure.ProcedureTemplateInformationFieldType", [], ProcedureTemplateInformationFieldType, () => [[], [], [], [], [], [], [], [], [["propertyConfigurationId", string_type]]]);
}

export class ProcedureTemplateStepElementType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Text", "MultilineText", "TextBlock", "IntNumber", "FloatNumber", "Bool", "DateTime", "Location", "Signature", "SingleSelect", "MultiSelect", "RadioSelect", "Image", "PhotoCapture", "InspectionResult", "Document", "CustomField", "ToolStateChange", "StorageTransfer", "ReminderCompletion", "SendEmail"];
    }
}

export function ProcedureTemplateStepElementType_$reflection() {
    return union_type("Shared.Procedure.ProcedureTemplateStepElementType", [], ProcedureTemplateStepElementType, () => [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]);
}

export const PhotoCapture_defaultMinCount = 1;

export const PhotoCapture_defaultMaxCount = 5;

export class ProcedureEmail_RecipientKind extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Address", "User", "StorageManagers", "Performer"];
    }
}

export function ProcedureEmail_RecipientKind_$reflection() {
    return union_type("Shared.Procedure.ProcedureEmail.RecipientKind", [], ProcedureEmail_RecipientKind, () => [[], [], [], []]);
}

export class ProcedureEmail_Recipient extends Record {
    constructor(Kind, Address, UserId, Name) {
        super();
        this.Kind = Kind;
        this.Address = Address;
        this.UserId = UserId;
        this.Name = Name;
    }
}

export function ProcedureEmail_Recipient_$reflection() {
    return record_type("Shared.Procedure.ProcedureEmail.Recipient", [], ProcedureEmail_Recipient, () => [["Kind", ProcedureEmail_RecipientKind_$reflection()], ["Address", option_type(string_type)], ["UserId", option_type(string_type)], ["Name", option_type(string_type)]]);
}

export function ProcedureEmail_address(value) {
    return new ProcedureEmail_Recipient(new ProcedureEmail_RecipientKind(0, []), value, undefined, undefined);
}

export function ProcedureEmail_user(userId, name) {
    return new ProcedureEmail_Recipient(new ProcedureEmail_RecipientKind(1, []), undefined, userId, name);
}

export const ProcedureEmail_storageManagers = new ProcedureEmail_Recipient(new ProcedureEmail_RecipientKind(2, []), undefined, undefined, undefined);

export const ProcedureEmail_performer = new ProcedureEmail_Recipient(new ProcedureEmail_RecipientKind(3, []), undefined, undefined, undefined);

export class ProcedureEmail_DispatchStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Queued", "NoRecipients"];
    }
}

export function ProcedureEmail_DispatchStatus_$reflection() {
    return union_type("Shared.Procedure.ProcedureEmail.DispatchStatus", [], ProcedureEmail_DispatchStatus, () => [[], []]);
}

export function ProcedureEmail_DispatchStatus__ToDbString(this$) {
    if (this$.tag === 1) {
        return "no_recipients";
    }
    else {
        return "queued";
    }
}

export function ProcedureEmail_DispatchStatus_TryParse_Z721C83C5(value) {
    switch (value) {
        case "queued":
            return new ProcedureEmail_DispatchStatus(0, []);
        case "no_recipients":
            return new ProcedureEmail_DispatchStatus(1, []);
        default:
            return undefined;
    }
}

export class ProcedureEmail_Dispatch extends Record {
    constructor(Recipients, SentAt, Status, RecipientsChanged) {
        super();
        this.Recipients = Recipients;
        this.SentAt = SentAt;
        this.Status = Status;
        this.RecipientsChanged = RecipientsChanged;
    }
}

export function ProcedureEmail_Dispatch_$reflection() {
    return record_type("Shared.Procedure.ProcedureEmail.Dispatch", [], ProcedureEmail_Dispatch, () => [["Recipients", list_type(string_type)], ["SentAt", class_type("System.DateTime")], ["Status", ProcedureEmail_DispatchStatus_$reflection()], ["RecipientsChanged", bool_type]]);
}

export class ProcedureEmail_ResolvedRecipientDto extends Record {
    constructor(Address, UserId, Name) {
        super();
        this.Address = Address;
        this.UserId = UserId;
        this.Name = Name;
    }
}

export function ProcedureEmail_ResolvedRecipientDto_$reflection() {
    return record_type("Shared.Procedure.ProcedureEmail.ResolvedRecipientDto", [], ProcedureEmail_ResolvedRecipientDto, () => [["Address", string_type], ["UserId", option_type(string_type)], ["Name", option_type(string_type)]]);
}

export class ProcedureEmail_RecipientUser extends Record {
    constructor(UserId, Name, Address) {
        super();
        this.UserId = UserId;
        this.Name = Name;
        this.Address = Address;
    }
}

export function ProcedureEmail_RecipientUser_$reflection() {
    return record_type("Shared.Procedure.ProcedureEmail.RecipientUser", [], ProcedureEmail_RecipientUser, () => [["UserId", string_type], ["Name", string_type], ["Address", string_type]]);
}

export class ProcedureEmail_SubmittedRecipient extends Record {
    constructor(UserId, Address) {
        super();
        this.UserId = UserId;
        this.Address = Address;
    }
}

export function ProcedureEmail_SubmittedRecipient_$reflection() {
    return record_type("Shared.Procedure.ProcedureEmail.SubmittedRecipient", [], ProcedureEmail_SubmittedRecipient, () => [["UserId", option_type(string_type)], ["Address", option_type(string_type)]]);
}

export function ProcedureEmail_submittedUser(userId) {
    return new ProcedureEmail_SubmittedRecipient(userId, undefined);
}

export function ProcedureEmail_submittedAddress(address) {
    return new ProcedureEmail_SubmittedRecipient(undefined, address);
}

export const ProcedureEmail_placeholders = ofArray(["display_name", "inventory_number", "storage_name", "performer", "date", "procedure_name", "result_link"]);

export class ProcedureTemplateStepElement extends Record {
    constructor(Id, ReadableId, Label, Position, Required, ElementType, InspectionTemplateId, PropertyConfigurationId, MinCount, MaxCount, AttachProtocolPdf, EmailRecipients, EmailSubject, EmailBody, AllowRecipientEditing) {
        super();
        this.Id = Id;
        this.ReadableId = ReadableId;
        this.Label = Label;
        this.Position = (Position | 0);
        this.Required = Required;
        this.ElementType = ElementType;
        this.InspectionTemplateId = InspectionTemplateId;
        this.PropertyConfigurationId = PropertyConfigurationId;
        this.MinCount = MinCount;
        this.MaxCount = MaxCount;
        this.AttachProtocolPdf = AttachProtocolPdf;
        this.EmailRecipients = EmailRecipients;
        this.EmailSubject = EmailSubject;
        this.EmailBody = EmailBody;
        this.AllowRecipientEditing = AllowRecipientEditing;
    }
}

export function ProcedureTemplateStepElement_$reflection() {
    return record_type("Shared.Procedure.ProcedureTemplateStepElement", [], ProcedureTemplateStepElement, () => [["Id", ProcedureTemplateStepElementId_$reflection()], ["ReadableId", string_type], ["Label", string_type], ["Position", int32_type], ["Required", bool_type], ["ElementType", ProcedureTemplateStepElementType_$reflection()], ["InspectionTemplateId", option_type(InspectionTemplateId_$reflection())], ["PropertyConfigurationId", option_type(string_type)], ["MinCount", option_type(int32_type)], ["MaxCount", option_type(int32_type)], ["AttachProtocolPdf", bool_type], ["EmailRecipients", list_type(ProcedureEmail_Recipient_$reflection())], ["EmailSubject", string_type], ["EmailBody", string_type], ["AllowRecipientEditing", bool_type]]);
}

export class ProcedureTemplateStep extends Record {
    constructor(Id, Position, Title, Description, Elements) {
        super();
        this.Id = Id;
        this.Position = (Position | 0);
        this.Title = Title;
        this.Description = Description;
        this.Elements = Elements;
    }
}

export function ProcedureTemplateStep_$reflection() {
    return record_type("Shared.Procedure.ProcedureTemplateStep", [], ProcedureTemplateStep, () => [["Id", ProcedureTemplateStepId_$reflection()], ["Position", int32_type], ["Title", string_type], ["Description", string_type], ["Elements", list_type(ProcedureTemplateStepElement_$reflection())]]);
}

export class ProcedureTemplateState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Draft", "Archived", "Released"];
    }
}

export function ProcedureTemplateState_$reflection() {
    return union_type("Shared.Procedure.ProcedureTemplateState", [], ProcedureTemplateState, () => [[], [], []]);
}

export class ProcedureTemplateInformationField extends Record {
    constructor(FieldType, Position) {
        super();
        this.FieldType = FieldType;
        this.Position = (Position | 0);
    }
}

export function ProcedureTemplateInformationField_$reflection() {
    return record_type("Shared.Procedure.ProcedureTemplateInformationField", [], ProcedureTemplateInformationField, () => [["FieldType", ProcedureTemplateInformationFieldType_$reflection()], ["Position", int32_type]]);
}

export class ProcedureTemplate extends Record {
    constructor(Id, State, Title, Description, Steps, InformationFields, CreatedAt, UpdatedAt) {
        super();
        this.Id = Id;
        this.State = State;
        this.Title = Title;
        this.Description = Description;
        this.Steps = Steps;
        this.InformationFields = InformationFields;
        this.CreatedAt = CreatedAt;
        this.UpdatedAt = UpdatedAt;
    }
}

export function ProcedureTemplate_$reflection() {
    return record_type("Shared.Procedure.ProcedureTemplate", [], ProcedureTemplate, () => [["Id", ProcedureTemplateId_$reflection()], ["State", ProcedureTemplateState_$reflection()], ["Title", string_type], ["Description", string_type], ["Steps", list_type(ProcedureTemplateStep_$reflection())], ["InformationFields", list_type(ProcedureTemplateInformationField_$reflection())], ["CreatedAt", class_type("System.DateTime")], ["UpdatedAt", class_type("System.DateTime")]]);
}

export class ChecklistDefinitionHook extends Record {
    constructor(ChecklistDefinitionId, Hooks) {
        super();
        this.ChecklistDefinitionId = ChecklistDefinitionId;
        this.Hooks = Hooks;
    }
}

export function ChecklistDefinitionHook_$reflection() {
    return record_type("Shared.Procedure.ChecklistDefinitionHook", [], ChecklistDefinitionHook, () => [["ChecklistDefinitionId", ProcedureTemplateId_$reflection()], ["Hooks", list_type(ChecklistDefinitionProcessStep_$reflection())]]);
}

export class ProcedureTemplateHookTriggerType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AssignmentReceiver", "AssignmentSender", "ReturnReceiver", "ReturnSender", "Handover", "Reservation", "StatusChange", "ManualStorageManager", "ManualUser"];
    }
}

export function ProcedureTemplateHookTriggerType_$reflection() {
    return union_type("Shared.Procedure.ProcedureTemplateHookTriggerType", [], ProcedureTemplateHookTriggerType, () => [[], [], [], [], [], [], [], [], []]);
}

export class ProcedureTemplateHook extends Record {
    constructor(Id, ProcedureTemplateId, TriggerType, IsMandatory, LabelIds, TargetStateKey, RoleIds) {
        super();
        this.Id = Id;
        this.ProcedureTemplateId = ProcedureTemplateId;
        this.TriggerType = TriggerType;
        this.IsMandatory = IsMandatory;
        this.LabelIds = LabelIds;
        this.TargetStateKey = TargetStateKey;
        this.RoleIds = RoleIds;
    }
}

export function ProcedureTemplateHook_$reflection() {
    return record_type("Shared.Procedure.ProcedureTemplateHook", [], ProcedureTemplateHook, () => [["Id", class_type("System.Guid")], ["ProcedureTemplateId", ProcedureTemplateId_$reflection()], ["TriggerType", ProcedureTemplateHookTriggerType_$reflection()], ["IsMandatory", bool_type], ["LabelIds", list_type(class_type("System.Guid"))], ["TargetStateKey", option_type(string_type)], ["RoleIds", list_type(class_type("System.Guid"))]]);
}

export class ProcedureTrigger extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Manual", "AssignmentSender", "AssignmentReceiver", "ReturnSender", "ReturnReceiver", "StatusChange"];
    }
}

export function ProcedureTrigger_$reflection() {
    return union_type("Shared.Procedure.ProcedureTrigger", [], ProcedureTrigger, () => [[], [], [], [], [], []]);
}

export function ExecuteStepType__get_TypeString(this$) {
    switch (this$) {
        case "boolStep":
            return "bool_step";
        case "singleSelectStep":
            return "single_select_step";
        case "multiSelectStep":
            return "multi_select_step";
        case "dateTimeStep":
            return "date_time_step";
        case "signatureStep":
            return "signature_step";
        case "imageStep":
            return "image_step";
        default:
            return "text_input_step";
    }
}

export class ProcedureStepInput extends Record {
    constructor(Id, ProcedureStepId, InputValue) {
        super();
        this.Id = Id;
        this.ProcedureStepId = ProcedureStepId;
        this.InputValue = InputValue;
    }
}

export function ProcedureStepInput_$reflection() {
    return record_type("Shared.Procedure.ProcedureStepInput", [], ProcedureStepInput, () => [["Id", class_type("System.Guid")], ["ProcedureStepId", ProcedureStepId_$reflection()], ["InputValue", string_type]]);
}

export class ProcedureStorageTransferResult extends Record {
    constructor(StorageId, StorageSpace) {
        super();
        this.StorageId = StorageId;
        this.StorageSpace = StorageSpace;
    }
}

export function ProcedureStorageTransferResult_$reflection() {
    return record_type("Shared.Procedure.ProcedureStorageTransferResult", [], ProcedureStorageTransferResult, () => [["StorageId", string_type], ["StorageSpace", string_type]]);
}

export class ProcedureReminderCompletionEntry extends Record {
    constructor(ReminderId, Comment$, CreateNewDate, NextInspectionDate, SetLastInspectionDate, LastInspectionDate) {
        super();
        this.ReminderId = ReminderId;
        this.Comment = Comment$;
        this.CreateNewDate = CreateNewDate;
        this.NextInspectionDate = NextInspectionDate;
        this.SetLastInspectionDate = SetLastInspectionDate;
        this.LastInspectionDate = LastInspectionDate;
    }
}

export function ProcedureReminderCompletionEntry_$reflection() {
    return record_type("Shared.Procedure.ProcedureReminderCompletionEntry", [], ProcedureReminderCompletionEntry, () => [["ReminderId", string_type], ["Comment", string_type], ["CreateNewDate", bool_type], ["NextInspectionDate", option_type(string_type)], ["SetLastInspectionDate", bool_type], ["LastInspectionDate", option_type(class_type("System.DateTime"))]]);
}

export class ProcedureStepElementResultValue extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Text", "IntNumber", "FloatNumber", "Bool", "DateTime", "Location", "Signature", "SingleSelect", "MultiSelect", "RadioSelect", "Image", "PhotoCapture", "InspectionResult", "Document", "CustomField", "ToolStateChange", "StorageTransfer", "ReminderCompletion", "SendEmail"];
    }
}

export function ProcedureStepElementResultValue_$reflection() {
    return union_type("Shared.Procedure.ProcedureStepElementResultValue", [], ProcedureStepElementResultValue, () => [[["Item", string_type]], [["Item", int32_type]], [["Item", float64_type]], [["Item", bool_type]], [["Item", class_type("System.DateTime")]], [], [], [["Item", string_type]], [["Item", list_type(string_type)]], [["Item", string_type]], [], [], [["Item", string_type]], [], [["Item", string_type]], [["Item", option_type(string_type)]], [["Item", option_type(ProcedureStorageTransferResult_$reflection())]], [["Item", list_type(ProcedureReminderCompletionEntry_$reflection())]], [["Item", option_type(ProcedureEmail_Dispatch_$reflection())]]]);
}

export function ProcedureStepElementResultValue__ResultToString(this$) {
    let matchResult, value, value_1, value_2, value_3, value_4, value_5, value_6, values, value_7, value_8, stateKey, result, entries, dispatch;
    switch (this$.tag) {
        case 11: {
            matchResult = 17;
            break;
        }
        case 5:
        case 6:
        case 10:
        case 13: {
            matchResult = 18;
            break;
        }
        case 1: {
            matchResult = 1;
            value_1 = this$.fields[0];
            break;
        }
        case 2: {
            matchResult = 2;
            value_2 = this$.fields[0];
            break;
        }
        case 3: {
            matchResult = 3;
            value_3 = this$.fields[0];
            break;
        }
        case 4: {
            matchResult = 4;
            value_4 = this$.fields[0];
            break;
        }
        case 7: {
            matchResult = 5;
            value_5 = this$.fields[0];
            break;
        }
        case 9: {
            matchResult = 6;
            value_6 = this$.fields[0];
            break;
        }
        case 8: {
            matchResult = 7;
            values = this$.fields[0];
            break;
        }
        case 12: {
            matchResult = 8;
            value_7 = this$.fields[0];
            break;
        }
        case 14: {
            matchResult = 9;
            value_8 = this$.fields[0];
            break;
        }
        case 15: {
            if (this$.fields[0] != null) {
                matchResult = 11;
                stateKey = this$.fields[0];
            }
            else {
                matchResult = 10;
            }
            break;
        }
        case 16: {
            if (this$.fields[0] != null) {
                matchResult = 13;
                result = this$.fields[0];
            }
            else {
                matchResult = 12;
            }
            break;
        }
        case 17: {
            matchResult = 14;
            entries = this$.fields[0];
            break;
        }
        case 18: {
            if (this$.fields[0] != null) {
                matchResult = 16;
                dispatch = this$.fields[0];
            }
            else {
                matchResult = 15;
            }
            break;
        }
        default: {
            matchResult = 0;
            value = this$.fields[0];
        }
    }
    switch (matchResult) {
        case 0:
            return value;
        case 1:
            return int32ToString(value_1);
        case 2:
            return value_2.toString();
        case 3:
            if (value_3) {
                return "Ja";
            }
            else {
                return "Nein";
            }
        case 4:
            return toString(toLocalTime(value_4), "dd.MM.yyyy");
        case 5:
            return value_5;
        case 6:
            return value_6;
        case 7:
            return join(", ", values);
        case 8:
            return value_7;
        case 9:
            return value_8;
        case 10:
            return "";
        case 11:
            return stateKey;
        case 12:
            return "";
        case 13:
            return result.StorageSpace;
        case 14:
            return int32ToString(length(entries));
        case 15:
            return "";
        case 16:
            return join(", ", dispatch.Recipients);
        case 17:
            return "";
        default:
            return "";
    }
}

export class ProcedureStepElementResult extends Record {
    constructor(Id, ProcedureTemplateStepElementId, Value, SignatureUrl, Comment$, DocumentUrls) {
        super();
        this.Id = Id;
        this.ProcedureTemplateStepElementId = ProcedureTemplateStepElementId;
        this.Value = Value;
        this.SignatureUrl = SignatureUrl;
        this.Comment = Comment$;
        this.DocumentUrls = DocumentUrls;
    }
}

export function ProcedureStepElementResult_$reflection() {
    return record_type("Shared.Procedure.ProcedureStepElementResult", [], ProcedureStepElementResult, () => [["Id", ProcedureStepElementResultId_$reflection()], ["ProcedureTemplateStepElementId", ProcedureTemplateStepElementId_$reflection()], ["Value", ProcedureStepElementResultValue_$reflection()], ["SignatureUrl", option_type(string_type)], ["Comment", option_type(string_type)], ["DocumentUrls", list_type(string_type)]]);
}

export class ProcedureStep extends Record {
    constructor(Id, ProcedureId, ProcedureTemplateStepId, Results, CreatedBy, CreatedAt, UpdatedAt) {
        super();
        this.Id = Id;
        this.ProcedureId = ProcedureId;
        this.ProcedureTemplateStepId = ProcedureTemplateStepId;
        this.Results = Results;
        this.CreatedBy = CreatedBy;
        this.CreatedAt = CreatedAt;
        this.UpdatedAt = UpdatedAt;
    }
}

export function ProcedureStep_$reflection() {
    return record_type("Shared.Procedure.ProcedureStep", [], ProcedureStep, () => [["Id", ProcedureStepId_$reflection()], ["ProcedureId", ProcedureId_$reflection()], ["ProcedureTemplateStepId", ProcedureTemplateStepId_$reflection()], ["Results", list_type(ProcedureStepElementResult_$reflection())], ["CreatedBy", string_type], ["CreatedAt", class_type("System.DateTime")], ["UpdatedAt", class_type("System.DateTime")]]);
}

export class ProcedureState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Started", "CompletedSuccessful", "CompletedFailed", "Cancelled"];
    }
}

export function ProcedureState_$reflection() {
    return union_type("Shared.Procedure.ProcedureState", [], ProcedureState, () => [[], [], [], []]);
}

export class Procedure extends Record {
    constructor(Id, ProcedureTemplateId, State, Name, Description, StartDate, EndDate, Steps, CreatedBy, CreatedAt, UpdatedAt, IsDeleted) {
        super();
        this.Id = Id;
        this.ProcedureTemplateId = ProcedureTemplateId;
        this.State = State;
        this.Name = Name;
        this.Description = Description;
        this.StartDate = StartDate;
        this.EndDate = EndDate;
        this.Steps = Steps;
        this.CreatedBy = CreatedBy;
        this.CreatedAt = CreatedAt;
        this.UpdatedAt = UpdatedAt;
        this.IsDeleted = IsDeleted;
    }
}

export function Procedure_$reflection() {
    return record_type("Shared.Procedure.Procedure", [], Procedure, () => [["Id", ProcedureId_$reflection()], ["ProcedureTemplateId", ProcedureTemplateId_$reflection()], ["State", ProcedureState_$reflection()], ["Name", string_type], ["Description", string_type], ["StartDate", class_type("System.DateTime")], ["EndDate", class_type("System.DateTime")], ["Steps", list_type(ProcedureStep_$reflection())], ["CreatedBy", string_type], ["CreatedAt", class_type("System.DateTime")], ["UpdatedAt", class_type("System.DateTime")], ["IsDeleted", bool_type]]);
}

export class ChecklistDefinitionStepDto extends Record {
    constructor(Type, NextStep) {
        super();
        this.Type = Type;
        this.NextStep = NextStep;
    }
}

export function ChecklistDefinitionStepDto_$reflection() {
    return record_type("Shared.Procedure.ChecklistDefinitionStepDto", [], ChecklistDefinitionStepDto, () => [["Type", ChecklistDefinitionStepType_$reflection()], ["NextStep", option_type(ChecklistDefinitionStepDto_$reflection())]]);
}

export class CreateChecklistDefinitionDto extends Record {
    constructor(Title, Description, ProcessStep, FirstStep, Active) {
        super();
        this.Title = Title;
        this.Description = Description;
        this.ProcessStep = ProcessStep;
        this.FirstStep = FirstStep;
        this.Active = Active;
    }
}

export function CreateChecklistDefinitionDto_$reflection() {
    return record_type("Shared.Procedure.CreateChecklistDefinitionDto", [], CreateChecklistDefinitionDto, () => [["Title", string_type], ["Description", string_type], ["ProcessStep", list_type(ChecklistDefinitionProcessStep_$reflection())], ["FirstStep", option_type(ChecklistDefinitionStepDto_$reflection())], ["Active", bool_type]]);
}

export class UpdateChecklistDefinitionDto extends Record {
    constructor(Id, Title, Description, ProcessStep, Steps, Active) {
        super();
        this.Id = Id;
        this.Title = Title;
        this.Description = Description;
        this.ProcessStep = ProcessStep;
        this.Steps = Steps;
        this.Active = Active;
    }
}

export function UpdateChecklistDefinitionDto_$reflection() {
    return record_type("Shared.Procedure.UpdateChecklistDefinitionDto", [], UpdateChecklistDefinitionDto, () => [["Id", class_type("System.Guid")], ["Title", string_type], ["Description", string_type], ["ProcessStep", list_type(ChecklistDefinitionProcessStep_$reflection())], ["Steps", list_type(ChecklistDefinitionStepType_$reflection())], ["Active", bool_type]]);
}

export class ProcedureTemplateOverviewDto extends Record {
    constructor(Id, Title, Description, State, CreatedAt) {
        super();
        this.Id = Id;
        this.Title = Title;
        this.Description = Description;
        this.State = State;
        this.CreatedAt = CreatedAt;
    }
}

export function ProcedureTemplateOverviewDto_$reflection() {
    return record_type("Shared.Procedure.ProcedureTemplateOverviewDto", [], ProcedureTemplateOverviewDto, () => [["Id", string_type], ["Title", string_type], ["Description", string_type], ["State", ProcedureTemplateState_$reflection()], ["CreatedAt", class_type("System.DateTime")]]);
}

export class ExecuteStepDto extends Record {
    constructor(Id, Title, Description, Required, Index, Type, Values, Result) {
        super();
        this.Id = Id;
        this.Title = Title;
        this.Description = Description;
        this.Required = Required;
        this.Index = (Index | 0);
        this.Type = Type;
        this.Values = Values;
        this.Result = Result;
    }
}

export function ExecuteStepDto_$reflection() {
    return record_type("Shared.Procedure.ExecuteStepDto", [], ExecuteStepDto, () => [["Id", string_type], ["Title", string_type], ["Description", string_type], ["Required", bool_type], ["Index", int32_type], ["Type", string_type], ["Values", anonRecord_type(["MultiSelect", option_type(list_type(string_type))], ["SingleSelect", option_type(list_type(string_type))])], ["Result", anonRecord_type(["Bool", option_type(bool_type)], ["DateTimeValue", option_type(class_type("System.DateTime"))], ["ImageUrls", option_type(list_type(string_type))], ["MultiSelect", option_type(list_type(string_type))], ["SignatureUrl", option_type(string_type)], ["SingleSelect", option_type(string_type)], ["TextInput", option_type(string_type)])]]);
}

export class ChecklistExecuteDto extends Record {
    constructor(Title, Description, Steps) {
        super();
        this.Title = Title;
        this.Description = Description;
        this.Steps = Steps;
    }
}

export function ChecklistExecuteDto_$reflection() {
    return record_type("Shared.Procedure.ChecklistExecuteDto", [], ChecklistExecuteDto, () => [["Title", string_type], ["Description", string_type], ["Steps", list_type(ExecuteStepDto_$reflection())]]);
}

export class StoredFileDto extends Record {
    constructor(StepId, Url) {
        super();
        this.StepId = StepId;
        this.Url = Url;
    }
}

export function StoredFileDto_$reflection() {
    return record_type("Shared.Procedure.StoredFileDto", [], StoredFileDto, () => [["StepId", string_type], ["Url", string_type]]);
}

export class DocumentBase64Dto extends Record {
    constructor(FileName, ContentType, Base64, Name, Description) {
        super();
        this.FileName = FileName;
        this.ContentType = ContentType;
        this.Base64 = Base64;
        this.Name = Name;
        this.Description = Description;
    }
}

export function DocumentBase64Dto_$reflection() {
    return record_type("Shared.Procedure.DocumentBase64Dto", [], DocumentBase64Dto, () => [["FileName", string_type], ["ContentType", string_type], ["Base64", string_type], ["Name", string_type], ["Description", string_type]]);
}

export class UploadedDocumentDto extends Record {
    constructor(DocumentId, FileName, Name, Description, IsVisibleForUserRole) {
        super();
        this.DocumentId = DocumentId;
        this.FileName = FileName;
        this.Name = Name;
        this.Description = Description;
        this.IsVisibleForUserRole = IsVisibleForUserRole;
    }
}

export function UploadedDocumentDto_$reflection() {
    return record_type("Shared.Procedure.UploadedDocumentDto", [], UploadedDocumentDto, () => [["DocumentId", string_type], ["FileName", string_type], ["Name", string_type], ["Description", string_type], ["IsVisibleForUserRole", bool_type]]);
}

export class ProcedureInformationFieldValueDto extends Record {
    constructor(Label, Value) {
        super();
        this.Label = Label;
        this.Value = Value;
    }
}

export function ProcedureInformationFieldValueDto_$reflection() {
    return record_type("Shared.Procedure.ProcedureInformationFieldValueDto", [], ProcedureInformationFieldValueDto, () => [["Label", string_type], ["Value", string_type]]);
}

export class ProcedureEntityReferenceDto extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Tool", "ToolWithQuantity", "Consumable", "Set"];
    }
}

export function ProcedureEntityReferenceDto_$reflection() {
    return union_type("Shared.Procedure.ProcedureEntityReferenceDto", [], ProcedureEntityReferenceDto, () => [[["toolId", string_type]], [["toolWithQuantityId", string_type]], [["consumableId", string_type]], [["setId", string_type]]]);
}

export function ProcedureEntityReferenceDto__get_EntityId(this$) {
    let id;
    switch (this$.tag) {
        case 1: {
            id = this$.fields[0];
            break;
        }
        case 2: {
            id = this$.fields[0];
            break;
        }
        case 3: {
            id = this$.fields[0];
            break;
        }
        default:
            id = this$.fields[0];
    }
    return id;
}

export class ProcedureEntitySetItemDto extends Record {
    constructor(ToolId, DisplayName) {
        super();
        this.ToolId = ToolId;
        this.DisplayName = DisplayName;
    }
}

export function ProcedureEntitySetItemDto_$reflection() {
    return record_type("Shared.Procedure.ProcedureEntitySetItemDto", [], ProcedureEntitySetItemDto, () => [["ToolId", string_type], ["DisplayName", string_type]]);
}

export class ProcedureEntityDto extends Record {
    constructor(Reference, DisplayName, Quantity, Unit, SetItems) {
        super();
        this.Reference = Reference;
        this.DisplayName = DisplayName;
        this.Quantity = Quantity;
        this.Unit = Unit;
        this.SetItems = SetItems;
    }
}

export function ProcedureEntityDto_$reflection() {
    return record_type("Shared.Procedure.ProcedureEntityDto", [], ProcedureEntityDto, () => [["Reference", ProcedureEntityReferenceDto_$reflection()], ["DisplayName", string_type], ["Quantity", option_type(float64_type)], ["Unit", option_type(string_type)], ["SetItems", list_type(ProcedureEntitySetItemDto_$reflection())]]);
}

export class ProcedureBookingType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Assignment", "Return", "Transfer"];
    }
}

export function ProcedureBookingType_$reflection() {
    return union_type("Shared.Procedure.ProcedureBookingType", [], ProcedureBookingType, () => [[], [], []]);
}

export class ProcedureBookingSide extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Sender", "Receiver"];
    }
}

export function ProcedureBookingSide_$reflection() {
    return union_type("Shared.Procedure.ProcedureBookingSide", [], ProcedureBookingSide, () => [[], []]);
}

export class ProcedureBookingDto extends Record {
    constructor(BookingType, Side, SenderName, ReceiverName, Quantity, Unit, SetItems, StorageName, BookingDate) {
        super();
        this.BookingType = BookingType;
        this.Side = Side;
        this.SenderName = SenderName;
        this.ReceiverName = ReceiverName;
        this.Quantity = Quantity;
        this.Unit = Unit;
        this.SetItems = SetItems;
        this.StorageName = StorageName;
        this.BookingDate = BookingDate;
    }
}

export function ProcedureBookingDto_$reflection() {
    return record_type("Shared.Procedure.ProcedureBookingDto", [], ProcedureBookingDto, () => [["BookingType", ProcedureBookingType_$reflection()], ["Side", ProcedureBookingSide_$reflection()], ["SenderName", string_type], ["ReceiverName", string_type], ["Quantity", option_type(float64_type)], ["Unit", option_type(string_type)], ["SetItems", list_type(ProcedureEntitySetItemDto_$reflection())], ["StorageName", option_type(string_type)], ["BookingDate", class_type("System.DateTime")]]);
}

export class ProcedureStateChangeDto extends Record {
    constructor(OldState, NewState, ChangedAt, ChangedByName) {
        super();
        this.OldState = OldState;
        this.NewState = NewState;
        this.ChangedAt = ChangedAt;
        this.ChangedByName = ChangedByName;
    }
}

export function ProcedureStateChangeDto_$reflection() {
    return record_type("Shared.Procedure.ProcedureStateChangeDto", [], ProcedureStateChangeDto, () => [["OldState", InventoryStateReference_$reflection()], ["NewState", InventoryStateReference_$reflection()], ["ChangedAt", class_type("System.DateTime")], ["ChangedByName", option_type(string_type)]]);
}

export class ProcedureStateChangeInfo extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Booked", "NotBooked"];
    }
}

export function ProcedureStateChangeInfo_$reflection() {
    return union_type("Shared.Procedure.ProcedureStateChangeInfo", [], ProcedureStateChangeInfo, () => [[["Item", ProcedureStateChangeDto_$reflection()]], []]);
}

export class DTO_ProcedureTemplateInformationFieldFormDto extends Record {
    constructor(FieldType, Position) {
        super();
        this.FieldType = FieldType;
        this.Position = (Position | 0);
    }
}

export function DTO_ProcedureTemplateInformationFieldFormDto_$reflection() {
    return record_type("Shared.Procedure.DTO.ProcedureTemplateInformationFieldFormDto", [], DTO_ProcedureTemplateInformationFieldFormDto, () => [["FieldType", ProcedureTemplateInformationFieldType_$reflection()], ["Position", int32_type]]);
}

export class DTO_ProcedureTemplateStepElementFormDto extends Record {
    constructor(Label, Position, Type, Required, Options, InspectionTemplateId, PropertyConfigurationId, MinCount, MaxCount, AttachProtocolPdf, EmailRecipients, EmailSubject, EmailBody, AllowRecipientEditing) {
        super();
        this.Label = Label;
        this.Position = (Position | 0);
        this.Type = Type;
        this.Required = Required;
        this.Options = Options;
        this.InspectionTemplateId = InspectionTemplateId;
        this.PropertyConfigurationId = PropertyConfigurationId;
        this.MinCount = MinCount;
        this.MaxCount = MaxCount;
        this.AttachProtocolPdf = AttachProtocolPdf;
        this.EmailRecipients = EmailRecipients;
        this.EmailSubject = EmailSubject;
        this.EmailBody = EmailBody;
        this.AllowRecipientEditing = AllowRecipientEditing;
    }
}

export function DTO_ProcedureTemplateStepElementFormDto_$reflection() {
    return record_type("Shared.Procedure.DTO.ProcedureTemplateStepElementFormDto", [], DTO_ProcedureTemplateStepElementFormDto, () => [["Label", string_type], ["Position", int32_type], ["Type", ProcedureTemplateStepElementType_$reflection()], ["Required", bool_type], ["Options", list_type(string_type)], ["InspectionTemplateId", option_type(string_type)], ["PropertyConfigurationId", option_type(string_type)], ["MinCount", option_type(int32_type)], ["MaxCount", option_type(int32_type)], ["AttachProtocolPdf", bool_type], ["EmailRecipients", list_type(ProcedureEmail_Recipient_$reflection())], ["EmailSubject", string_type], ["EmailBody", string_type], ["AllowRecipientEditing", bool_type]]);
}

export class DTO_ProcedureTemplateStepFormDto extends Record {
    constructor(Name, Description, Position, Elements) {
        super();
        this.Name = Name;
        this.Description = Description;
        this.Position = (Position | 0);
        this.Elements = Elements;
    }
}

export function DTO_ProcedureTemplateStepFormDto_$reflection() {
    return record_type("Shared.Procedure.DTO.ProcedureTemplateStepFormDto", [], DTO_ProcedureTemplateStepFormDto, () => [["Name", string_type], ["Description", string_type], ["Position", int32_type], ["Elements", list_type(DTO_ProcedureTemplateStepElementFormDto_$reflection())]]);
}

export class DTO_ProcedureTemplateHookFormDto extends Record {
    constructor(TriggerType, IsMandatory, LabelIds, TargetStateKey, RoleIds) {
        super();
        this.TriggerType = TriggerType;
        this.IsMandatory = IsMandatory;
        this.LabelIds = LabelIds;
        this.TargetStateKey = TargetStateKey;
        this.RoleIds = RoleIds;
    }
}

export function DTO_ProcedureTemplateHookFormDto_$reflection() {
    return record_type("Shared.Procedure.DTO.ProcedureTemplateHookFormDto", [], DTO_ProcedureTemplateHookFormDto, () => [["TriggerType", ProcedureTemplateHookTriggerType_$reflection()], ["IsMandatory", bool_type], ["LabelIds", list_type(class_type("System.Guid"))], ["TargetStateKey", option_type(string_type)], ["RoleIds", list_type(class_type("System.Guid"))]]);
}

export class DTO_AssignmentHookDto extends Record {
    constructor(ProcedureTemplateId, ProcedureTemplateName, IsMandatory) {
        super();
        this.ProcedureTemplateId = ProcedureTemplateId;
        this.ProcedureTemplateName = ProcedureTemplateName;
        this.IsMandatory = IsMandatory;
    }
}

export function DTO_AssignmentHookDto_$reflection() {
    return record_type("Shared.Procedure.DTO.AssignmentHookDto", [], DTO_AssignmentHookDto, () => [["ProcedureTemplateId", class_type("System.Guid")], ["ProcedureTemplateName", string_type], ["IsMandatory", bool_type]]);
}

export class DTO_ManualHookDto extends Record {
    constructor(ProcedureTemplateId, ProcedureTemplateName, TriggerType) {
        super();
        this.ProcedureTemplateId = ProcedureTemplateId;
        this.ProcedureTemplateName = ProcedureTemplateName;
        this.TriggerType = TriggerType;
    }
}

export function DTO_ManualHookDto_$reflection() {
    return record_type("Shared.Procedure.DTO.ManualHookDto", [], DTO_ManualHookDto, () => [["ProcedureTemplateId", class_type("System.Guid")], ["ProcedureTemplateName", string_type], ["TriggerType", ProcedureTemplateHookTriggerType_$reflection()]]);
}

export class DTO_SenderHookDto extends Record {
    constructor(ProcedureTemplateId, ProcedureTemplateName, IsMandatory, IsCompleted, ProcedureId) {
        super();
        this.ProcedureTemplateId = ProcedureTemplateId;
        this.ProcedureTemplateName = ProcedureTemplateName;
        this.IsMandatory = IsMandatory;
        this.IsCompleted = IsCompleted;
        this.ProcedureId = ProcedureId;
    }
}

export function DTO_SenderHookDto_$reflection() {
    return record_type("Shared.Procedure.DTO.SenderHookDto", [], DTO_SenderHookDto, () => [["ProcedureTemplateId", class_type("System.Guid")], ["ProcedureTemplateName", string_type], ["IsMandatory", bool_type], ["IsCompleted", bool_type], ["ProcedureId", option_type(class_type("System.Guid"))]]);
}

export class DTO_GetSenderHooksRequest extends Record {
    constructor(CategoryIds, ToolId, EntityReference) {
        super();
        this.CategoryIds = CategoryIds;
        this.ToolId = ToolId;
        this.EntityReference = EntityReference;
    }
}

export function DTO_GetSenderHooksRequest_$reflection() {
    return record_type("Shared.Procedure.DTO.GetSenderHooksRequest", [], DTO_GetSenderHooksRequest, () => [["CategoryIds", list_type(class_type("System.Guid"))], ["ToolId", string_type], ["EntityReference", option_type(ProcedureEntityReferenceDto_$reflection())]]);
}

export class DTO_StatusChangeHookDto extends Record {
    constructor(ProcedureTemplateId, ProcedureTemplateName, IsMandatory, IsCompleted, ProcedureId, TargetStateKey) {
        super();
        this.ProcedureTemplateId = ProcedureTemplateId;
        this.ProcedureTemplateName = ProcedureTemplateName;
        this.IsMandatory = IsMandatory;
        this.IsCompleted = IsCompleted;
        this.ProcedureId = ProcedureId;
        this.TargetStateKey = TargetStateKey;
    }
}

export function DTO_StatusChangeHookDto_$reflection() {
    return record_type("Shared.Procedure.DTO.StatusChangeHookDto", [], DTO_StatusChangeHookDto, () => [["ProcedureTemplateId", class_type("System.Guid")], ["ProcedureTemplateName", string_type], ["IsMandatory", bool_type], ["IsCompleted", bool_type], ["ProcedureId", option_type(class_type("System.Guid"))], ["TargetStateKey", string_type]]);
}

export class DTO_GetStatusChangeHooksRequest extends Record {
    constructor(CategoryIds, EntityReference, TargetStateKey) {
        super();
        this.CategoryIds = CategoryIds;
        this.EntityReference = EntityReference;
        this.TargetStateKey = TargetStateKey;
    }
}

export function DTO_GetStatusChangeHooksRequest_$reflection() {
    return record_type("Shared.Procedure.DTO.GetStatusChangeHooksRequest", [], DTO_GetStatusChangeHooksRequest, () => [["CategoryIds", list_type(class_type("System.Guid"))], ["EntityReference", ProcedureEntityReferenceDto_$reflection()], ["TargetStateKey", string_type]]);
}

export class DTO_CreateProcedureDto extends Record {
    constructor(ToolId, EntityReference, Trigger) {
        super();
        this.ToolId = ToolId;
        this.EntityReference = EntityReference;
        this.Trigger = Trigger;
    }
}

export function DTO_CreateProcedureDto_$reflection() {
    return record_type("Shared.Procedure.DTO.CreateProcedureDto", [], DTO_CreateProcedureDto, () => [["ToolId", option_type(string_type)], ["EntityReference", option_type(ProcedureEntityReferenceDto_$reflection())], ["Trigger", option_type(ProcedureTrigger_$reflection())]]);
}

export class DTO_ProcedureTemplateFormDto extends Record {
    constructor(Name, Description, State, Steps, Hooks, InformationFields) {
        super();
        this.Name = Name;
        this.Description = Description;
        this.State = State;
        this.Steps = Steps;
        this.Hooks = Hooks;
        this.InformationFields = InformationFields;
    }
}

export function DTO_ProcedureTemplateFormDto_$reflection() {
    return record_type("Shared.Procedure.DTO.ProcedureTemplateFormDto", [], DTO_ProcedureTemplateFormDto, () => [["Name", string_type], ["Description", string_type], ["State", ProcedureTemplateState_$reflection()], ["Steps", list_type(DTO_ProcedureTemplateStepFormDto_$reflection())], ["Hooks", list_type(DTO_ProcedureTemplateHookFormDto_$reflection())], ["InformationFields", list_type(DTO_ProcedureTemplateInformationFieldFormDto_$reflection())]]);
}

export class DTO_ProcedureTemplateStepElementDto extends Record {
    constructor(Id, Label, Position, Type, Options, InspectionTemplateId, InspectionTemplateName, PropertyConfigurationId, MinCount, MaxCount, AttachProtocolPdf, EmailRecipients, EmailSubject, EmailBody, AllowRecipientEditing) {
        super();
        this.Id = Id;
        this.Label = Label;
        this.Position = (Position | 0);
        this.Type = Type;
        this.Options = Options;
        this.InspectionTemplateId = InspectionTemplateId;
        this.InspectionTemplateName = InspectionTemplateName;
        this.PropertyConfigurationId = PropertyConfigurationId;
        this.MinCount = MinCount;
        this.MaxCount = MaxCount;
        this.AttachProtocolPdf = AttachProtocolPdf;
        this.EmailRecipients = EmailRecipients;
        this.EmailSubject = EmailSubject;
        this.EmailBody = EmailBody;
        this.AllowRecipientEditing = AllowRecipientEditing;
    }
}

export function DTO_ProcedureTemplateStepElementDto_$reflection() {
    return record_type("Shared.Procedure.DTO.ProcedureTemplateStepElementDto", [], DTO_ProcedureTemplateStepElementDto, () => [["Id", string_type], ["Label", string_type], ["Position", int32_type], ["Type", ProcedureTemplateStepElementType_$reflection()], ["Options", list_type(string_type)], ["InspectionTemplateId", option_type(string_type)], ["InspectionTemplateName", option_type(string_type)], ["PropertyConfigurationId", option_type(string_type)], ["MinCount", option_type(int32_type)], ["MaxCount", option_type(int32_type)], ["AttachProtocolPdf", bool_type], ["EmailRecipients", list_type(ProcedureEmail_Recipient_$reflection())], ["EmailSubject", string_type], ["EmailBody", string_type], ["AllowRecipientEditing", bool_type]]);
}

export class DTO_ProcedureTemplateStepDto extends Record {
    constructor(Id, Name, Description, Position, Elements) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Description = Description;
        this.Position = (Position | 0);
        this.Elements = Elements;
    }
}

export function DTO_ProcedureTemplateStepDto_$reflection() {
    return record_type("Shared.Procedure.DTO.ProcedureTemplateStepDto", [], DTO_ProcedureTemplateStepDto, () => [["Id", string_type], ["Name", string_type], ["Description", string_type], ["Position", int32_type], ["Elements", list_type(DTO_ProcedureTemplateStepElementDto_$reflection())]]);
}

export class DTO_ProcedureTemplateDto extends Record {
    constructor(Id, Name, Description, Steps) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Description = Description;
        this.Steps = Steps;
    }
}

export function DTO_ProcedureTemplateDto_$reflection() {
    return record_type("Shared.Procedure.DTO.ProcedureTemplateDto", [], DTO_ProcedureTemplateDto, () => [["Id", string_type], ["Name", string_type], ["Description", string_type], ["Steps", list_type(DTO_ProcedureTemplateStepDto_$reflection())]]);
}

export class DTO_ProcedureStepElementResultDto extends Record {
    constructor(Id, ProcedureTemplateStepElementId, Value) {
        super();
        this.Id = Id;
        this.ProcedureTemplateStepElementId = ProcedureTemplateStepElementId;
        this.Value = Value;
    }
}

export function DTO_ProcedureStepElementResultDto_$reflection() {
    return record_type("Shared.Procedure.DTO.ProcedureStepElementResultDto", [], DTO_ProcedureStepElementResultDto, () => [["Id", string_type], ["ProcedureTemplateStepElementId", string_type], ["Value", ProcedureStepElementResultValue_$reflection()]]);
}

export class DTO_ProcedureStepDto extends Record {
    constructor(ProcedureTemplateStepId, Results) {
        super();
        this.ProcedureTemplateStepId = ProcedureTemplateStepId;
        this.Results = Results;
    }
}

export function DTO_ProcedureStepDto_$reflection() {
    return record_type("Shared.Procedure.DTO.ProcedureStepDto", [], DTO_ProcedureStepDto, () => [["ProcedureTemplateStepId", ProcedureTemplateStepId_$reflection()], ["Results", list_type(ProcedureStepElementResult_$reflection())]]);
}

export class DTO_ProcedureDto extends Record {
    constructor(Id, State, Name, Description, StartDate, EndDate, Steps) {
        super();
        this.Id = Id;
        this.State = State;
        this.Name = Name;
        this.Description = Description;
        this.StartDate = StartDate;
        this.EndDate = EndDate;
        this.Steps = Steps;
    }
}

export function DTO_ProcedureDto_$reflection() {
    return record_type("Shared.Procedure.DTO.ProcedureDto", [], DTO_ProcedureDto, () => [["Id", string_type], ["State", ProcedureState_$reflection()], ["Name", string_type], ["Description", string_type], ["StartDate", class_type("System.DateTime")], ["EndDate", option_type(class_type("System.DateTime"))], ["Steps", list_type(DTO_ProcedureStepDto_$reflection())]]);
}

export function DTO_tryFindProcedureStep(procedure, templateStepId) {
    return tryFind((step) => (toString_1(step.ProcedureTemplateStepId) === templateStepId), procedure.Steps);
}

export function DTO_isProcedureStepCompleted(procedureStep) {
    return procedureStep != null;
}

export class DTO_ProcedureStepEmailRecipientsDto extends Record {
    constructor(ProcedureTemplateStepElementId, Recipients) {
        super();
        this.ProcedureTemplateStepElementId = ProcedureTemplateStepElementId;
        this.Recipients = Recipients;
    }
}

export function DTO_ProcedureStepEmailRecipientsDto_$reflection() {
    return record_type("Shared.Procedure.DTO.ProcedureStepEmailRecipientsDto", [], DTO_ProcedureStepEmailRecipientsDto, () => [["ProcedureTemplateStepElementId", string_type], ["Recipients", list_type(ProcedureEmail_ResolvedRecipientDto_$reflection())]]);
}

export class DTO_ProcedureFormDto extends Record {
    constructor(Procedure, ProcedureTemplate, InformationFieldValues, CurrentToolStateKey, OpenReminders, Entity, Booking, StateChange, PerformedBy, EditableEmailRecipients, EmailRecipientUsers) {
        super();
        this.Procedure = Procedure;
        this.ProcedureTemplate = ProcedureTemplate;
        this.InformationFieldValues = InformationFieldValues;
        this.CurrentToolStateKey = CurrentToolStateKey;
        this.OpenReminders = OpenReminders;
        this.Entity = Entity;
        this.Booking = Booking;
        this.StateChange = StateChange;
        this.PerformedBy = PerformedBy;
        this.EditableEmailRecipients = EditableEmailRecipients;
        this.EmailRecipientUsers = EmailRecipientUsers;
    }
}

export function DTO_ProcedureFormDto_$reflection() {
    return record_type("Shared.Procedure.DTO.ProcedureFormDto", [], DTO_ProcedureFormDto, () => [["Procedure", DTO_ProcedureDto_$reflection()], ["ProcedureTemplate", DTO_ProcedureTemplateDto_$reflection()], ["InformationFieldValues", list_type(ProcedureInformationFieldValueDto_$reflection())], ["CurrentToolStateKey", option_type(string_type)], ["OpenReminders", list_type(ReminderDateDto_$reflection())], ["Entity", option_type(ProcedureEntityDto_$reflection())], ["Booking", option_type(ProcedureBookingDto_$reflection())], ["StateChange", option_type(ProcedureStateChangeInfo_$reflection())], ["PerformedBy", option_type(string_type)], ["EditableEmailRecipients", list_type(DTO_ProcedureStepEmailRecipientsDto_$reflection())], ["EmailRecipientUsers", list_type(ProcedureEmail_RecipientUser_$reflection())]]);
}

export class DTO_WriteProcedureStepElementResultDto extends Record {
    constructor(ProcedureTemplateStepElementId, Type, TextValue, IntNumberValue, FloatNumberValue, BoolValue, DateTimeValue, SignatureBase64, SingleSelectValue, MultiSelectValue, InspectionResultValue, InspectionResultComment, UploadedDocuments, PhotoUrls, CustomFieldValue, ToolStateChangeValue, ToolStateChangeComment, StorageTransferStorageId, StorageTransferStorageSpace, ReminderCompletionEntries, EmailRecipients) {
        super();
        this.ProcedureTemplateStepElementId = ProcedureTemplateStepElementId;
        this.Type = Type;
        this.TextValue = TextValue;
        this.IntNumberValue = IntNumberValue;
        this.FloatNumberValue = FloatNumberValue;
        this.BoolValue = BoolValue;
        this.DateTimeValue = DateTimeValue;
        this.SignatureBase64 = SignatureBase64;
        this.SingleSelectValue = SingleSelectValue;
        this.MultiSelectValue = MultiSelectValue;
        this.InspectionResultValue = InspectionResultValue;
        this.InspectionResultComment = InspectionResultComment;
        this.UploadedDocuments = UploadedDocuments;
        this.PhotoUrls = PhotoUrls;
        this.CustomFieldValue = CustomFieldValue;
        this.ToolStateChangeValue = ToolStateChangeValue;
        this.ToolStateChangeComment = ToolStateChangeComment;
        this.StorageTransferStorageId = StorageTransferStorageId;
        this.StorageTransferStorageSpace = StorageTransferStorageSpace;
        this.ReminderCompletionEntries = ReminderCompletionEntries;
        this.EmailRecipients = EmailRecipients;
    }
}

export function DTO_WriteProcedureStepElementResultDto_$reflection() {
    return record_type("Shared.Procedure.DTO.WriteProcedureStepElementResultDto", [], DTO_WriteProcedureStepElementResultDto, () => [["ProcedureTemplateStepElementId", string_type], ["Type", ProcedureTemplateStepElementType_$reflection()], ["TextValue", option_type(string_type)], ["IntNumberValue", option_type(int32_type)], ["FloatNumberValue", option_type(float64_type)], ["BoolValue", option_type(bool_type)], ["DateTimeValue", option_type(class_type("System.DateTime"))], ["SignatureBase64", option_type(string_type)], ["SingleSelectValue", option_type(string_type)], ["MultiSelectValue", option_type(list_type(string_type))], ["InspectionResultValue", option_type(string_type)], ["InspectionResultComment", option_type(string_type)], ["UploadedDocuments", option_type(list_type(UploadedDocumentDto_$reflection()))], ["PhotoUrls", option_type(list_type(string_type))], ["CustomFieldValue", option_type(string_type)], ["ToolStateChangeValue", option_type(string_type)], ["ToolStateChangeComment", option_type(string_type)], ["StorageTransferStorageId", option_type(string_type)], ["StorageTransferStorageSpace", option_type(string_type)], ["ReminderCompletionEntries", option_type(list_type(ProcedureReminderCompletionEntry_$reflection()))], ["EmailRecipients", option_type(list_type(ProcedureEmail_SubmittedRecipient_$reflection()))]]);
}

export function DTO_WriteProcedureStepElementResultDto_Empty() {
    return new DTO_WriteProcedureStepElementResultDto("", new ProcedureTemplateStepElementType(0, []), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}

export class DTO_WriteProcedureStepDto extends Record {
    constructor(Results) {
        super();
        this.Results = Results;
    }
}

export function DTO_WriteProcedureStepDto_$reflection() {
    return record_type("Shared.Procedure.DTO.WriteProcedureStepDto", [], DTO_WriteProcedureStepDto, () => [["Results", list_type(DTO_WriteProcedureStepElementResultDto_$reflection())]]);
}

export class DTO_ProcedureTemplateTestElementDto extends Record {
    constructor(Id, Type, Required, MinCount, MaxCount, Options) {
        super();
        this.Id = Id;
        this.Type = Type;
        this.Required = Required;
        this.MinCount = MinCount;
        this.MaxCount = MaxCount;
        this.Options = Options;
    }
}

export function DTO_ProcedureTemplateTestElementDto_$reflection() {
    return record_type("Shared.Procedure.DTO.ProcedureTemplateTestElementDto", [], DTO_ProcedureTemplateTestElementDto, () => [["Id", string_type], ["Type", ProcedureTemplateStepElementType_$reflection()], ["Required", bool_type], ["MinCount", option_type(int32_type)], ["MaxCount", option_type(int32_type)], ["Options", list_type(string_type)]]);
}

export class DTO_ValidateProcedureTemplateTestStepDto extends Record {
    constructor(Elements, Results) {
        super();
        this.Elements = Elements;
        this.Results = Results;
    }
}

export function DTO_ValidateProcedureTemplateTestStepDto_$reflection() {
    return record_type("Shared.Procedure.DTO.ValidateProcedureTemplateTestStepDto", [], DTO_ValidateProcedureTemplateTestStepDto, () => [["Elements", list_type(DTO_ProcedureTemplateTestElementDto_$reflection())], ["Results", list_type(DTO_WriteProcedureStepElementResultDto_$reflection())]]);
}

export class DTO_CompleteProcedureTemplateTestDto extends Record {
    constructor(StepIds, CompletedStepIds) {
        super();
        this.StepIds = StepIds;
        this.CompletedStepIds = CompletedStepIds;
    }
}

export function DTO_CompleteProcedureTemplateTestDto_$reflection() {
    return record_type("Shared.Procedure.DTO.CompleteProcedureTemplateTestDto", [], DTO_CompleteProcedureTemplateTestDto, () => [["StepIds", list_type(string_type)], ["CompletedStepIds", list_type(string_type)]]);
}

